import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export function LoadingSpinner() {
  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <CircularProgress />
    </Box>
  );
}